import { graphql, useStaticQuery } from 'gatsby';
import React, { useState } from 'react';

import ChevronDownSvg from "../assets/icons/chevron-down.svg";
import ChevronRightSvg from "../assets/icons/chevron-right.svg";
import CommandeSvg from "../assets/icons/commande-en-gros.svg";
import DélaisSvg from "../assets/icons/devis-sous-24_H.svg";
import ImpressionSvg from "../assets/icons/impression.svg";


// questionProduit (optionnel) : { question, reponse } spécifique à la fiche produit,
// affichée en dernier, quel que soit l'onglet actif (cf. src/data/faq-produits.json).
const FAQProductView = ({ questionProduit }) => {

  const data = useStaticQuery(query);
  const [sectionIndex, setSectionIndex] = useState(0);
  const [itemIndex, setItemIndex] = useState(null);

  const faq = [
    {
      title: "Commandes",
      icon: CommandeSvg,
      children: [
        {
          question: "Quel est le délai pour recevoir un devis ?",
          answer: "Réponse en 24 à 48 h après réception de votre demande (parfois 1h 😁)"
        },
        {
          question: "Quels sont les modes de paiement acceptés ?",
          answer: "Le règlement peut être effectué par carte bancaire, virement ou chèque. Sauf accord préalable, la production est lancée après réception du paiement. Nous acceptons également les bons de commande administratifs via Chorus."
        },
        {
          question: "Comment suivre l’avancement de ma commande ?",
          answer: "Nous vous tenons informé par email à chaque étape : devis, BAT, production, expédition, livraison"
        },
        {
          question: "Fournissez-vous un bon à tirer (BAT) ?",
          answer: "Oui, un BAT est systématiquement fourni avant lancement de la production. Il permet de valider le visuel final à imprimer"
        },
        {
          question: "Y a‑t‑il un minimum de commandes ?",
          answer: "Oui, le minimum standard est de 100 pièces par modèle et par visuel. Une quantité de 50 pièces peut être étudiée pour certains produits ou réassorts."
        },
        {
          question: "Proposez-vous des réductions pour les grosses quantités ?",
          answer: "Oui, nos tarifs sont dégressifs selon le volume. Plus vous commandez, plus le prix à l’unité diminue."
        },
        {
          question: "Puis-je commander sans impression ? (vierge)",
          answer: "Oui, il est tout à fait possible de commander des tote bags sans impression. Merci de le préciser lors de la demande."
        },
        {
          question: "Quel format de fichier faut-il fournir pour l’impression ?",
          answer: "Nous recommandons un fichier vectoriel (.ai, .eps, .pdf) pour une qualité optimale. Si besoin, nous pouvons vous aider à le retravailler."
        },
        {
          question: "Proposez-vous des conseils graphiques ou un accompagnement design ?",
          answer: "Oui, notre équipe peut vous aider à adapter votre visuel pour un rendu optimal sur tote bag (placement, couleur, taille, contraste…)."
        }
      ]
    },
    {
      title: "Impressions",
      icon: ImpressionSvg,
      children: [
        {
          question: "Quelles techniques d’impression utilisez-vous ?",
          answer: "Nous proposons sérigraphie (couleurs vives et durables), impression numérique (dégradés, photos), transfert sérigraphique, broderie et broderie 3D"
        },
        {
          question: "Quelle est la différence entre la sérigraphie et l’impression numérique ?",
          answer: "La sérigraphie est idéale pour les logos simples et en aplats de couleur (jusqu’à 6 couleurs), très résistante dans le temps. L’impression numérique permet des visuels complexes, dégradés ou photos."
        },
        {
          question: "Faites-vous des impressions en quadri (quadrichromie) ?",
          answer: "Oui, notamment via l’impression numérique, qui permet des rendus photo réalistes en quadrichromie (CMJN)."
        },
        {
          question: "Est-ce que les encres sont écologiques ?",
          answer: "Oui, nous utilisons des encres à base d’eau ou certifiées OEKO-TEX® STANDARD 100, respectueuses de l’environnement."
        },
        {
          question: "Les impressions résistent-elles au lavage ?",
          answer: "Oui, toutes nos impressions sont testées pour une bonne tenue, même après plusieurs lavages. La sérigraphie est particulièrement durable."
        },
        {
          question: "Puis-je imprimer sur les deux faces ?",
          answer: "Oui, vous choisissez l'imprimé recto ou recto/verso selon vos besoins."
        },
        {
          question: "Peut-on faire un prototype avant la commande finale ?",
          answer: "Oui, nous pouvons produire un échantillon ou maquette virtuelle avant validation"
        }
      ]
    },
    {
      title: "Livraison",
      icon: DélaisSvg,
      children: [
        {
          question: "Puis-je me faire livrer à plusieurs adresses ?",
          answer: "Oui, la livraison multi-sites est possible. Il suffit de nous fournir la répartition souhaitée lors de la commande"
        },
        {
          question: "Quels transporteurs utilisez-vous ?",
          answer: "Nous travaillons avec des partenaires fiables comme Colissimo, Chronopost, UPS ou DHL, selon le type de livraison et la destination"
        },
        {
          question: "Proposez-vous une livraison suivie ?",
          answer: "Oui, un numéro de suivi est fourni dès que le colis est expédié. Vous pouvez suivre l’acheminement en temps réel"
        },
        {
          question: "Livrez-vous en Suisse et au Royaume-Uni ?",
          answer: "Oui, nous livrons également en Suisse et au Royaume-Uni. Merci de préciser votre pays pour un devis ajusté (droits de douane éventuels à prévoir)"
        },
        {
          question: "Puis-je choisir une livraison en point relais ?",
          answer: "Oui, sur demande, nous pouvons organiser une livraison en point relais pour plus de flexibilité."
        },
        {
          question: "La livraison est-elle gratuite ?",
          answer: "La livraison standard est gratuite en France et en Europe pour toute commande professionnelle, sauf cas particuliers (urgences ou multi-adresses)"
        },
        {
          question: "Livrez-vous en Europe ?",
          answer: "Oui, livraison gratuite en Europe via nos services partenaires."
        },
        {
          question: "Livrez-vous en dehors de l’Europe ?",
          answer: "Oui, contactez‑nous pour un devis adapté aux zones concernées."
        },
        {
          question: "Quel est le délai de livraison ?",
          answer: "Production et expédition sous 7 à 10 jours ouvrés après validation du BAT et réception du règlement. Livraison offerte en France métropolitaine."
        },
        {
          question: "Proposez-vous un service express ?",
          answer: "Oui, nous proposons un service express (48 à 72 h de production) selon faisabilité. Contactez-nous en urgence pour en bénéficier"
        }
      ]
    }
  ]


  return <div className='mt-8'>
    <div className="mb-8">
      <h2 className="text-center text-blue font-semibold mb-8">FAQ ! Besoin d'aide ?</h2>
      <div className="grid grid-cols-3 gap-x-4">
        {faq.map((section, i) => <button
          key={section.title}
          onClick={() => { setSectionIndex(i); setItemIndex(null); }}
          className="border:none bg-blue bg-opacity-10 hover:bg-opacity-40 p-4 rounded-2xl flex flex-col items-center justify-around">
          <section.icon className="w-20" />
          <h3 className="text-blue m-0 font-semibold">{section.title}</h3>
        </button>
        )}
      </div>

      <ul className="mt-4">
        {faq[sectionIndex].children.map((child, i) => <li key={child.question}>
          <div
            className='cursor-pointer bg-lightGray px-2 py-1 font-bold text-blue mb-4 flex items-center gap-2'
            onClick={() => itemIndex === i ? setItemIndex(null) : setItemIndex(i)}>
            {itemIndex === i ? <ChevronDownSvg className='w-8' /> : <ChevronRightSvg className='w-8' />}
            {child.question}
          </div>
          <p className={`pl-8 text-blue ${itemIndex === i ? 'block' : 'hidden'}`}>{child.answer}</p>
        </li>)}
        {questionProduit && <li key="produit">
          <div
            className='cursor-pointer bg-lightGray px-2 py-1 font-bold text-blue mb-4 flex items-center gap-2'
            onClick={() => itemIndex === 'produit' ? setItemIndex(null) : setItemIndex('produit')}>
            {itemIndex === 'produit' ? <ChevronDownSvg className='w-8' /> : <ChevronRightSvg className='w-8' />}
            {questionProduit.question}
          </div>
          <p className={`pl-8 text-blue ${itemIndex === 'produit' ? 'block' : 'hidden'}`}>{questionProduit.reponse}</p>
        </li>}
      </ul>
    </div>



  </div>
}


const query = graphql`
    query {
      image1: file(
      relativePath: {eq: "totebag-faq.jpg" }
      sourceInstanceName: {eq: "uploads" }
      ) {
        childImageSharp {
        gatsbyImageData(width: 300, height: 380) 
      }
    }
     
  }
      `;


export default FAQProductView
